import { useState } from "react";
import Login from "../Login";
import classes from './Account.module.scss';


declare function Translate(key: string): string;

const Account = () => {
   
    return (
        <>                       
            {/* <div className={classes.up_note}>
                <div role="heading" aria-level={1} className={classes.title}>{Translate('N_Login_info_1')}</div>
                <div role="heading" aria-level={2} className={classes.subTitle}>{Translate('N_Login_Sub_Title')}</div>                        
            </div>                           */}
            <div className={classes['login-wrapper-container']}>                    
                <Login isLandingPage={false} updateLoginStage={() => {}}/>                   
            </div>              
        </>
    );
}
export default Account;